import { motion } from "framer-motion";
import { PRODUCTS } from "@/lib/site";
import { Syringe, Clock, Layers, Gauge } from "lucide-react";

export default function Products() {
  return (
    <section id="portafolio" data-testid="products-section" className="relative py-20 md:py-28">
      <div className="max-w-[1160px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-12 gap-6 mb-10 md:mb-14 items-end">
          <div className="col-span-12 md:col-span-8">
            <span className="chip mb-5">
              <span className="dot" /> Portafolio · 3 líneas
            </span>
            <h2 className="font-display text-3xl md:text-5xl lg:text-[56px] font-bold text-[#0B0B14] tracking-tight leading-[1.05]">
              Tres perfiles reológicos. Una matriz clínica.
            </h2>
          </div>
          <p className="col-span-12 md:col-span-4 text-[#3A3A48] text-[15px] md:text-base leading-relaxed">
            HA cross-linked BDDE, 24 mg/mL, lidocaína 0.3%. Se diferencian en G′,
            tan δ y cohesividad — elige por indicación anatómica.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {PRODUCTS.map((p, i) => (
            <motion.article
              key={p.code}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`product-card-${p.code}`}
              className={`card-soft relative p-7 md:p-8 overflow-hidden hover:shadow-[0_20px_60px_-20px_rgba(124,106,245,0.35)] transition-shadow duration-500 ${
                i === 1 ? "md:mt-8" : ""
              }`}
            >
              <div className="absolute -top-6 -right-4 font-display text-[10rem] leading-none font-extrabold text-[#7C6AF5]/[0.06] pointer-events-none select-none">
                {p.code}
              </div>

              <div className="relative">
                <div className="flex items-center justify-between mb-8">
                  <span className="chip">Model · {p.code}</span>
                  <div className="w-9 h-9 rounded-full bg-[#F1EDFF] flex items-center justify-center">
                    <Syringe className="w-4 h-4 text-[#5A48C9]" strokeWidth={1.7} />
                  </div>
                </div>

                <h3 className="font-display text-2xl md:text-3xl font-bold text-[#0B0B14] tracking-tight mb-1">
                  {p.name}
                </h3>
                <p className="text-sm text-[#5A48C9] font-semibold mb-5">{p.role}</p>

                <p className="text-[#3A3A48] text-[14.5px] leading-relaxed mb-6 min-h-[76px]">
                  {p.use}
                </p>

                <ul className="space-y-2.5">
                  <Spec icon={Layers} label="HA" value={p.ha} />
                  <Spec icon={Gauge} label="G′" value={p.gprime} />
                  <Spec icon={Syringe} label="Aguja" value={p.needle} />
                  <Spec icon={Clock} label="Duración" value={p.duration} />
                </ul>

                <div className="mt-6 pt-5 border-t border-black/[0.06]">
                  <p className="text-[10.5px] font-semibold uppercase tracking-widest text-[#6B6B7D]">
                    Profundidad
                  </p>
                  <p className="mt-1 text-sm text-[#0B0B14] font-medium">{p.depth}</p>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

function Spec({ icon: Icon, label, value }) {
  return (
    <li className="flex items-center justify-between py-1.5 border-b border-black/[0.05] last:border-0">
      <span className="flex items-center gap-2 text-[#6B6B7D] text-[11px] font-semibold uppercase tracking-widest">
        <Icon className="w-3.5 h-3.5 text-[#7C6AF5]" strokeWidth={1.7} />
        {label}
      </span>
      <span className="text-[#0B0B14] font-display font-bold text-[15px]">{value}</span>
    </li>
  );
}
